import Cookies from 'js-cookie';
import axios from 'axios';

// Auth utility functions for debugging and token management

export const clearAuthData = () => {
  Cookies.remove("token");
  Cookies.remove("adminData");
};

export const getTokenInfo = () => {
  const token = Cookies.get("token");
  console.log("Retrieved token:", token); // Debug log
  if (!token) {
    return null;
  }

  try {
    // Decode JWT token (without verification)
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (error) {
    return null;
  }
};

export const isTokenValid = () => {
  const tokenInfo = getTokenInfo();
  if (!tokenInfo) return false;

  const now = Math.floor(Date.now() / 1000);
  const isValid = tokenInfo.exp > now;

  if (!isValid) {
    clearAuthData();
  }

  return isValid;
};

export const getAuthToken = () => {
  const token = Cookies.get("token");
  if (!token) return null;

  if (!isTokenValid()) {
    return null;
  }

  return token;
};

export const debugAuth = () => {
  // Debug function kept for future use but without console logs
  const token = Cookies.get("token");
  const tokenInfo = getTokenInfo();
  const isValid = isTokenValid();
  return { token, tokenInfo, isValid };
};

export const logout = () => {
  clearAuthData();
};

// In utils/auth.ts or wherever your verifyToken function is defined
export const verifyToken = async (setIsTokenValid: React.Dispatch<React.SetStateAction<boolean | null>>) => {
  try {
    const token = Cookies.get('emptoken');
    if (!token) {
      setIsTokenValid(false); // Token is invalid
      return null;
    }

  const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/verification`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    });

    if (response.data.success) {
      setIsTokenValid(true); // Token is valid
      return response.data.user;
    } else {
      setIsTokenValid(false); // Invalid token
      return null;
    }
  } catch (error) {
    console.error('Token verification failed:', error);
    setIsTokenValid(false); // Invalid token or expired
    return null;
  }
};

export const verifyadminToken = async (setIsTokenValid: React.Dispatch<React.SetStateAction<boolean | null>>) => {
  try {
    const token = Cookies.get('token');
    if (!token) {
      setIsTokenValid(false); // Token is invalid
      return null;
    }

      const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/verification`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    });


    if (response.data.success) {
      setIsTokenValid(true); // Token is valid
      return response.data.user;
    } else {
      setIsTokenValid(false); // Invalid token
      return null;
    }
  } catch (error) {
    console.error('Token verification failed:', error);
    setIsTokenValid(false); // Invalid token or expired
    return null;
  }
};
